export default __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers-9b0ea26c8b2420aca93bf1c2975343a6.svg";